// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'POST',
    endpoint: '/api/ordini/:id/righe/:rigaId/contrattualizzazione',
    requestBody: '{"dataInizio":"string","dataFine":"string","periodicita":"string","modalitaPagamento":"string","descrizione":"string"}',
    response: '{"success":true,"data":{"contrattoId":"number","numero":"string"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
